var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"tournament"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[(_vm.getTournament)?_c('div',{staticClass:"col-12 pt-3"},[_c('Head'),_c('NextMatch'),_c('Main')],1):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }